import { css } from '@linaria/core'
import { theme } from '#styles/themes'

export const dialogClass = css`
  > ._dialog {
    min-width: 600px;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    > header {
      padding: 24px 24px 12px;
      display: flex;
      justify-content: space-between;
      z-index: 1;

      position: sticky;
      top: 0;
      background-color: ${theme.backgroundSurfacePrimaryStrong};

      > .icon.accent {
        color: ${theme.textAccent};
      }
    }

    > main {
      flex: 1;
      position: relative;
      overflow-y: hidden;

      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 24px;
      flex-wrap: wrap;

      > ._busy-message, > ._error-message {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 24px;
        flex: 1;
      }

      > ._error-message {
        overflow-y: auto;
      }
    }

    > footer {
      padding: 12px 24px;
      background-color: ${theme.backgroundSurfacePrimaryStrong};
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: sticky;
      bottom: 0;
      gap: 8px;

      > .footer-note {
        display: flex;
        align-items: center;
        gap: 8px;
        color: ${theme.textSoft};
        font-size: 14px;
        line-height: 20px;
        padding-right: 20px;
        margin-right: auto;
        max-width: 60%;
      }
    }
  }
`
